import { css } from "@emotion/react";
import { debounce } from "lodash";
import { useMemo } from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";

type Props = {
  input: FieldRenderProps<string | boolean, HTMLElement>;
  customColorChecked: boolean;
  invertCheckmark: boolean;
  customColor: boolean;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const colorLabelStyles = (color?: string) => css`
  width: 30px;
  height: 30px;
  cursor: pointer;
  margin-left: 10px;
  border: 1px solid var(${DesignToken.BorderBasicDisabled});
  ${color && `background-color: ${color};`};
  ${!color &&
  `
    background-image: conic-gradient(rgb(0, 255, 255), rgb(255, 0, 255), rgb(255, 255, 0), rgb(0, 255, 255));
    background-size: 110% 110%;
    background-repeat: no-repeat;
    background-position: center;
  `};
  border-radius: 50%;
`;

const colorInputStyles = css`
  visibility: hidden;
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const checkmarkStyles = (invert = false) => css`
  height: 20px;
  width: 20px;
  position: relative;
  top: 5px;
  left: 6px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuOTk4OTQyIDUuODk5NUw2LjY1NTggMTEuNTU2NEwxNC42MjY2IDMuNTg1NTRMMTYuNTU1MyAxLjY1Njg1IiBzdHJva2U9IiM0MjRENTciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    no-repeat left center;

  ${invert &&
  `background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuOTk4OTQyIDUuODk5NUw2LjY1NTggMTEuNTU2NEwxNC42MjY2IDMuNTg1NTRMMTYuNTU1MyAxLjY1Njg1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K")
    no-repeat left center;"`}
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function getPropertyEventName(eventName: string) {
  if (eventName.includes("BodyBgColor")) {
    return "background";
  }
  if (eventName.includes("ContentBgColor")) {
    return "text box";
  }
  if (eventName.includes("TextColor")) {
    return "text";
  }
  if (eventName.includes("LinkColor")) {
    return "link";
  }
  if (eventName.includes("FooterTextColor")) {
    return "footer text";
  }
  if (eventName.includes("FooterLinkColor")) {
    return "footer link";
  }
  return "";
}

export const ColorPicker = ({
  customColorChecked = false,
  invertCheckmark = false,
  input,
  customColor = false,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
}: Props) => {
  const onChangeDebounced = useMemo(() => debounce(input.onChange, 500), [input.onChange]);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function handleClick() {
    trackEngagement(
      `Visual template editor: Appearance ${getPropertyEventName(input.name)} color changed`,
      EventPlace.Settings,
      { colorType: customColor ? "custom" : "predefined" }
    );
  }
  return (
    <label css={() => colorLabelStyles(input.value)}>
      {input.checked && <div css={() => checkmarkStyles(invertCheckmark)} />}
      {customColorChecked && <div css={() => checkmarkStyles(invertCheckmark)} />}
      {customColor ? (
        <input
          type="color"
          value={input.value}
          onChange={onChangeDebounced}
          css={colorInputStyles}
          onClick={handleClick}
        />
      ) : (
        <input {...input} css={colorInputStyles} type="radio" onClick={handleClick} />
      )}
    </label>
  );
};
